/**
 * 고객 이용문의 서비스
 */

import apiClient from './api';
import {
  Inquiry,
  InquiryFilter,
  InquiryListResponse,
  InquiryStats,
  InquiryResponse,
} from '../types/inquiry';

export const inquiryService = {
  /**
   * 문의 목록 조회
   */
  async getInquiries(filter: InquiryFilter = {}): Promise<InquiryListResponse> {
    const params = new URLSearchParams();
    
    if (filter.inquiry_type) params.append('inquiry_type', filter.inquiry_type);
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: InquiryListResponse }>(`/admin/inquiries?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      inquiries: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 문의 상세 조회
   */
  async getInquiry(id: number): Promise<Inquiry> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { inquiry: Inquiry } }>(`/admin/inquiries/${id}`);
    // return response.data.data.inquiry;

    throw new Error('Not implemented');
  },

  /**
   * 문의 답변 작성
   */
  async respondToInquiry(id: number, data: InquiryResponse): Promise<Inquiry> {
    // TODO: 백엔드 API 구현 후 연동
    // const formData = new FormData();
    // formData.append('response', data.response);
    // if (data.attachments) {
    //   data.attachments.forEach((file, index) => {
    //     formData.append(`attachments[${index}]`, file);
    //   });
    // }
    // const response = await apiClient.post<{ data: { inquiry: Inquiry } }>(`/admin/inquiries/${id}/respond`, formData, {
    //   headers: { 'Content-Type': 'multipart/form-data' }
    // });
    // return response.data.data.inquiry;

    throw new Error('Not implemented');
  },

  /**
   * 문의 상태 변경
   */
  async updateInquiryStatus(id: number, status: Inquiry['status']): Promise<Inquiry> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { inquiry: Inquiry } }>(`/admin/inquiries/${id}/status`, { status });
    // return response.data.data.inquiry;

    throw new Error('Not implemented');
  },

  /**
   * 문의 통계 조회
   */
  async getInquiryStats(filter?: { start_date?: string; end_date?: string }): Promise<InquiryStats> {
    const params = new URLSearchParams();
    if (filter?.start_date) params.append('start_date', filter.start_date);
    if (filter?.end_date) params.append('end_date', filter.end_date);

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { stats: InquiryStats } }>(`/admin/inquiries/stats?${params.toString()}`);
    // return response.data.data.stats;

    // 임시: 더미 데이터 반환
    return {
      total_count: 0,
      pending_count: 0,
      in_progress_count: 0,
      completed_count: 0,
      cancelled_count: 0,
      by_type: {},
    };
  },
};

